import { StateCreator } from 'zustand';
import { createAppStore } from '@marriott/mi-store-utils';

export interface SavedCard {
  id: string;
  cardNumber: string;
  cardholderName: string;
  cardType: string;
  expiryDate: string;
  isPrimary: boolean;
  cardArt?: string;
  cardStatus?: string;
  /** UXL cobrand.issuerProduct.code (PREP = Boundless) */
  issuerProductCode?: string;
}

export interface SavedCardState {
  selectedSavedCard?: SavedCard | null;
  setSelectedSavedCard: (card: SavedCard | null) => void;
  savedCards?: SavedCard[];
  setProfileSavedCards: (cards: SavedCard[]) => void;
  resetSavedCardState: () => void;
}

const initialState: SavedCardState = {
  selectedSavedCard: undefined,
  setSelectedSavedCard: () => {},
  savedCards: undefined,
  setProfileSavedCards: () => {},
  resetSavedCardState: () => {},
};

const SavedCardStore: StateCreator<SavedCardState> = set => {
  return {
    ...initialState,
    setSelectedSavedCard: (card: SavedCard | null) => {
      set(() => ({
        selectedSavedCard: card,
      }));
    },
    setProfileSavedCards: (cards: SavedCard[]) => {
      set({ savedCards: cards });
    },
    resetSavedCardState: () => {
      set(initialState);
    },
  };
};

export const useSavedCardsStore = createAppStore(SavedCardStore, {
  usePersistentStore: true,
  persistentStoreName: 'SavedCardStore',
});
